import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import {
  FormControl,
  FormBuilder,
  FormGroup,
  FormArray,
  Validators,
} from "@angular/forms";
import { StakeholderReferenceDto, CountryDto } from "@cradua/data";

import Swal from "sweetalert2";

interface ReferenceType {
  value: string;
  viewValue: string;
}

interface ReferenceStruct {
  Id: string;
  Name: string;
  Desc: string;
  Address: string;
  Location: string;
}

@Component({
  selector: "mrsoftapps-GenericReference",
  templateUrl: "./GenericReference.component.html",
  styleUrls: ["./GenericReference.component.css"],
})
export class GenericReferenceComponent implements OnInit {
  @Input()
  stakeholderreferences: StakeholderReferenceDto[];
  @Input()
  countries: CountryDto[];
  @Input()
  stakeholdergroups: any[];
  stakeholderreferenceForm: FormGroup;
  @Input()
  options: StakeholderReferenceDto[];
  @Output()
  selectedRefType = new EventEmitter<string>();
  @Output()
  selectedCountry = new EventEmitter<string>();
  @Output()
  selectedStakeholderGroup = new EventEmitter<string>();
  @Input()
  selectedReferenceType: string;
  @Input()
  selectedCountryId: string;
  @Input()
  selectedStakeholderGroupId: string;

  @Input()
  routeAnimationsElements: any;
  @Output()
  changeEmit = new EventEmitter<StakeholderReferenceDto>();
  @Output()
  deleteEvent = new EventEmitter<any>();
  @Output()
  printEvent = new EventEmitter<any>();

  selectedStakeholder: any;
  filteredDelete: Array<any> = [];
  loading = true;

  selectedMenuName: string = "Reference Type";
  countryId: string;

  control = new FormControl();
  referencetypes: ReferenceType[] = [
    { value: "Club", viewValue: "Club" },
    { value: "ContactType", viewValue: "Contact Type" },
    { value: "Language", viewValue: "Language" },
    { value: "League", viewValue: "League" },
    { value: "Organization", viewValue: "Organization" },
    { value: "Property", viewValue: "Property" },
    { value: "Sector", viewValue: "Sector" },
    { value: "SocialMediaType", viewValue: "Social Media Type" },
    { value: "AreaOfInterest", viewValue: "Area Of Interest" },
    { value: "PoliticalParty", viewValue: "Political Party" },
    { value: "StakeholderGroup", viewValue: "Group" },
    { value: "StakeholderSubGroup", viewValue: "Sub Group" },
    { value: "Title", viewValue: "Title" },
    { value: "LineOfBusiness", viewValue: "Line Of Business" },
    { value: "EngagementType", viewValue: "Type of Engagement" },
    { value: "EngagementCategory", viewValue: "Category of Engagement" },
    { value: "EngagementDriver", viewValue: "Engagement Driver" },
    { value: "Company", viewValue: "Company" },
    { value: "DocumentType", viewValue: "Document Type" },
    { value: "DocumentSecurity", viewValue: "Document Security" },
    {
      value: "DocumentPhysicalLocation",
      viewValue: "Document Physical Location",
    },
  ];
  constructor(private fb: FormBuilder) {}
  ngOnInit() {
    this.referencetypes = this.referencetypes.sort(function (a, b) {
      if (a.value < b.value) {
        return -1;
      }
      if (a.value > b.value) {
        return 1;
      }
      return 0;
    });
    this.stakeholderreferenceForm = this.fb.group({
      SelectedCountryId: [this.selectedCountryId],
      StakeholderReferences: this.fb.array([]),
    });
    this.setStakeholderReference();

    console.log("Grid Data ", this.stakeholderreferences);
  }

  clickme(value) {
    console.log("click ", value);
  }

  setStakeholderReference() {
    const control = this.stakeholderreferenceForm.controls
      .StakeholderReferences as FormArray;
    this.stakeholderreferences.forEach((e) => {
      control.push(
        this.fb.group({
          Name: e.Name,
          Desc: e.Desc,
          Address: e.Address,
          Location: e.Location,
          CountryId: e.CountryId,
          SubscriberId: e.SubscriberId,
          SiteId: e.SiteId,
          SectorId: e.SectorId,
          StakeholderGroupId: e.StakeholderGroupId,
          id: e.id,
        }),
      );
    });
  }

  // method to add Country
  addStakeholderReference() {
    if (
      this.selectedReferenceType === "Club" ||
      this.selectedReferenceType === "League"
    ) {
      if (this.selectedCountryId === undefined) {
        return;
      }
    }

    if (this.selectedReferenceType === "StakeholderSubGroup") {
      if (this.selectedStakeholderGroupId === undefined) {
        return;
      }
    }

    if (this.selectedReferenceType === "Organization") {
      if (this.selectedStakeholderGroupId === undefined) {
        return;
      }
    }
    const control = this.stakeholderreferenceForm.controls
      .StakeholderReferences as FormArray;
    control.insert(
      0,
      this.fb.group({
        Name: ["", Validators.required],
        Desc: [""],
        Address: [""],
        Location: [""],
        CountryId: [this.selectedCountryId],
        SubscriberId: [""],
        SiteId: [""],
        SectorId: [this.selectedStakeholderGroupId],
        StakeholderGroupId: [this.selectedStakeholderGroupId],
        id: null,
      }),
    );
  }

  print(event: any) {
    window.print();
  }
  // method to delete country from arrary list
  deleteStakeholderReference(index, value) {
    Swal.fire({
      title: "Are you sure?",
      text: "You will not be able to recover this record!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
    }).then((result) => {
      if (result.value) {
        const control = this.stakeholderreferenceForm.controls
          .StakeholderReferences as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.stakeholderreferences.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.stakeholderreferences[i].id);
            }
          }
        }
        Swal.fire("Deleted!", "Your record has been deleted.", "success");
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelled", "Your record is safe :)", "error");
      }
    });
  }

  onSubmit(formValue: any) {
    //formValue.type = 'country';
    this.changeEmit.emit(formValue);
    if (this.filteredDelete.length !== 0) {
      this.filteredDelete.unshift();
      console.log("On Submit event ", this.filteredDelete);
      this.deleteEvent.emit(this.filteredDelete);
    }
  }

  selectedValueChange(type: string) {
    event.preventDefault();
    this.selectedMenuName = type;
    console.log("Selected Reference type ", this.selectedMenuName);
    this.selectedRefType.emit(type);
  }

  selectedCountryChange(event) {
    //event.preventDefault();
    console.log(event.value);

    this.selectedCountry.emit(event.value);
  }

  selectedStakeholderGroupChange(event) {
    //event.preventDefault();
    console.log(event.value);

    this.selectedStakeholderGroup.emit(event.value);
  }
}
